import React from 'react';
import { Cancel as CancelIcon, Edit as EditIcon } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { Colors } from '../../../assets/theme/Colors';

const LassoSelector = ({ onClick, showLassoOverlay = false }) => (
  <Box
    sx={{
      zIndex: 5,
      position: 'absolute',
      top: 70,
      left: 70,
      px: 2,
      py: 1,
      borderRadius: 10,
      border: `1px solid`,
      borderColor: !showLassoOverlay ? Colors.secondarblyColor : 'error.main',
      color: !showLassoOverlay ? Colors.secondaryColor : 'error.main',
      bgcolor: 'background.paper',
      cursor: 'pointer',
    }}
    boxShadow={25}
    onClick={onClick}
  >
    {!showLassoOverlay && (
      <Box sx={{ display: 'flex', gap: 1 }}>
        <EditIcon />
        <Typography variant="body1" sx={{ fontWeight: 700 }}>
          Select
        </Typography>
      </Box>
    )}
    {showLassoOverlay && (
      <Box sx={{ display: 'flex', gap: 1 }}>
        <CancelIcon />
        <Typography variant="body1" sx={{ fontWeight: 700 }}>
          Cancel
        </Typography>
      </Box>
    )}
  </Box>
);

export default LassoSelector;
